<template>
  <nav role="navigation" class="c-pagination">
    <slot />
    <ul class="c-pagination inline listless" v-if="!tablePagination">
      <li class="u-hide-mobile">
        <a href="#" class="item btn-nav icon" @click="gotoPage(1)">First</a>
      </li>
      <li class="u-hide-mobile">
        <a href="#" class="item btn-nav icon" @click="gotoPage('prev')">Prev</a>
      </li>
      <li v-for="i in paginationArray" :key="i">
        <a
          href="#"
          class="item"
          :class="{ active: i == localPagination.current_page }"
          @click="gotoPage(i)"
          >{{ i }}</a
        >
      </li>
      <li class="u-hide-mobile">
        <a href="#" class="item btn-nav icon" @click="gotoPage('next')">Next</a>
      </li>
      <li class="u-hide-mobile">
        <a
          href="#"
          class="item btn-nav icon"
          @click="gotoPage(localPagination.last_page)"
          >Last</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  data() {
    return {
      localPagination: {},
    };
  },
  props: {
    pagination: {
      type: Object,
      default: () => {},
    },
    tablePagination: {
      type: Boolean,
      default: false,
    },
    current: {
      type: [Number, String],
      default: 1,
    },
  },
  computed: {
    paginationArray() {
      //determine the pagination numbers we can see.  should be no more then 5 numbers visible at a time
      let returnArray = [];
      const currentPage = parseInt(this.localPagination.current_page);
      if (currentPage < 4) {
        const lastpage =
          this.localPagination.last_page > 5
            ? 5
            : this.localPagination.last_page;
        for (let i = 1; i <= lastpage; i++) {
          returnArray.push(i);
        }
      } else if (currentPage >= this.localPagination.last_page - 3) {
        for (
          let i = this.localPagination.last_page;
          i >= this.localPagination.last_page - 3;
          i--
        ) {
          returnArray.unshift(i);
        }
        return returnArray;
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          returnArray.push(i);
        }
      }
      return returnArray;
    },
  },
  methods: {
    gotoPage(page) {
      let nextPage;

      switch (page) {
        case "next":
          nextPage = this.localPagination.current_page + 1;
          break;
        case "prev":
          nextPage = this.localPagination.current_page - 1;
          break;
        default:
          nextPage = page;
          break;
      }
      // Make a clean copy of the current query
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.page = nextPage;
      this.$router.replace({ query: queries });
      this.$emit("onPageClick", nextPage);
    },
  },
  watch: {
    current: {
      immediate: true,
      handler(newVal) {
        this.localPagination.current_page = newVal;
      },
    },
    pagination: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.localPagination = newValue;
      },
    },
  },
};
</script>

<style lang="scss">
.c-pagination {
  .item {
    background-color: rgb(232, 237, 238);
    border-radius: 3px;
    display: inline-block;
    box-sizing: border-box;
    color: rgb(0, 94, 184);
    display: inline-block;
    font-size: 20px;
    font-weight: 400;
    padding: 10px 20px;
    text-decoration: none;
    margin: 10px 10px 0 0;
    transition: all ease-in-out 0.2s;

    &:hover {
      background: darken(rgb(232, 237, 238), 10%);
    }

    &.disabled {
      opacity: 0.5;
    }

    &.btn-nav {
      // display: none;

      &.icon {
        display: none;

        @media (min-width: 640px) {
          display: inline-block;
        }
      }

      .angle {
        font-style: normal;

        &.double {
          &:after {
            content: "First";
            display: block;
            position: relative;
          }

          &.right {
            &:after {
              content: "Last";
            }
          }
        }
      }
      .chevron {
        font-style: normal;
        &:after {
          content: "Previous";
          display: block;
          position: relative;
        }

        &.right {
          &:after {
            content: "Next";
          }
        }
      }
    }

    &.active {
      background: rgb(0, 94, 184);
      color: rgb(255, 255, 255);
    }
  }
}
</style>
